import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions, SideBarDef } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import 'ag-grid-enterprise';

@Component({
    selector: 'app-travel-insurance-report',
    templateUrl: './travel-insurance-report.component.html',
    styleUrls: ['./travel-insurance-report.component.css'],
    standalone: false
})
export class TravelInsuranceReportComponent implements OnInit, AfterViewInit {

  showSearchUI = false;
  travelInsuranceReportData: any = [];

  // forms
  formLoading = false;
  currentSearchForm: any = {};
  defaultStartDate: Date
  defaultEndDate: Date
  defaultReservationStatuses: any;
  defaultShortTermRentalIds: any;

  // ag-grid
  gridApi: GridApi;
  columnApi: ColumnApi;
  gridOptions: GridOptions = {};

  // color rules
  occupancyNtsCellClassRule: CellClassRules = this.reportService.occupancyNtsCellClassRule;
  occupancyPctCellClassRule: CellClassRules = this.reportService.occupancyPctCellClassRule;

  autoGroupColumnDef = {
    headerName: 'Date',
    cellRendererParams: {
      suppressCount: true,
      // checkbox: true,
    }
  };

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
  };


  columnDefs = [
    { headerName: 'Order ID', field: 'orderId' },
    { headerName: 'Reservation ID', field: 'reservationId' },
    { headerName: 'Property Code', field: 'propertyCode' },
    { headerName: 'First Name', field: 'firstName' },
    { headerName: 'Last Name', field: 'lastName' },
    { headerName: 'Home Country', field: 'homeCountry' },
    { headerName: 'Home Street', field: 'homeStreet' },
    { headerName: 'Home State', field: 'homeState' },
    { headerName: 'Sale Date', field: 'saleDate', cellRenderer: this.fullDateTimeCellRendererUSD },
    { headerName: 'Check-In Date', field: 'checkInDateTime', cellRenderer: this.fullDateCellRendererUSD },
    { headerName: 'Check-Out Date', field: 'checkOutDateTime', cellRenderer: this.fullDateCellRendererUSD },
    { headerName: 'Invoice Total', field: 'invoiceTotal', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'Coupon Discount', field: 'couponDiscount', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'Final Invoice Total', field: 'finalInvoiceTotal', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'Insurance Paid By Guest', field: 'insuranceAmntPaidByGuest', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'Expected Insurance Amount (8%)', field: 'expectedInsuranceAmount8Pct', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'Insurance Amount Tax', field: 'insuranceAmountTax', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'CSA Invoice Total', field: 'csaInvoiceTotal', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'CSA Insurance Fee (7%)', field: 'csaInsuranceFee7Pct', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'CSA Insurance Paid By Guest', field: 'csaInsurancePaidByGuest', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'CSA Net Premium (65%)', field: 'csaNetPremium65Pct', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
    { headerName: 'KBM Insurance Revenue (35%)', field: 'kbmInsuranceRevenue35Pct', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' }
  ];

  exportItems = [
    { label: 'Export as CSV', icon: 'pi pi-file', command: () => { this.exportGridData('csv'); } },
    { label: 'Export as Excel', icon: 'pi pi-file-excel', command: () => { this.exportGridData('excel'); } }
  ];

  constructor(
    public messageService: MessageService,
    public reportService: ReportService
  ) { }


  async ngOnInit() {
    await this.setInitialDates();
    this.setAgGridOptions();
    this.showSearchUI = true;
    await this.getTravelInsuranceReport({ saleDateStart: this.defaultStartDate, saleDateEnd : this.defaultEndDate });
  }

  setInitialDates() {
    return new Promise((resolve, reject) => {
      this.defaultStartDate = new Date();
      this.defaultStartDate = new Date(this.defaultStartDate.getFullYear(), this.defaultStartDate.getMonth(), 1);
      this.defaultEndDate = new Date(this.defaultStartDate.getFullYear(), this.defaultStartDate.getMonth() + 1, 0);
      resolve(true);
    });
  }

  setAgGridOptions() {
    this.defaultReservationStatuses = ['OP', 'OO', 'OG'];
    this.defaultShortTermRentalIds = [1];

    // ag-grid
    this.gridOptions.rowData = this.travelInsuranceReportData;
    this.gridOptions.columnDefs = this.columnDefs;
    this.gridOptions.autoGroupColumnDef = this.autoGroupColumnDef;
    this.gridOptions.pagination = true;
    this.gridOptions.suppressAggFuncInHeader = true;
    this.gridOptions.animateRows = true;
    this.gridOptions.defaultColDef = this.defaultColDef;
    this.gridOptions.groupIncludeFooter = true;
    this.gridOptions.groupIncludeTotalFooter = true;
  }

  currencyCellRendererUSD(params: any) {
    let inrFormat = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return inrFormat.format(params.value);
  }

  fullDateCellRendererUSD(params: any) {
    if (params.data) {
      return moment(params.value).format('MM/DD/YY')
    }
  }

  fullDateTimeCellRendererUSD(params: any) {
    if (params.data) {
      return moment(params.value).format('MM/DD/YY HH:mm')
    }
  }

  ngAfterViewInit(): void {
    this.gridOptions.animateRows = true;
    (this.gridOptions as any).api?.setColumnDefs(this.columnDefs);
  }

  onGridReady(grid: any): void {
    this.gridApi = grid.api;
    this.columnApi = grid.columnApi;
  }


  exportGridData( type = 'csv') {
    type == 'csv' ? this.gridApi.exportDataAsCsv({ fileName: 'travel-insurance-report.csv' }) : this.gridApi.exportDataAsExcel({ fileName: 'travel-insurance-report.xlsx' });
  }


  onFirstDataRendered(params: any): void {
    setTimeout(() => { this.columnApi.autoSizeAllColumns(); }, 2000);
  }

  onRowGroupOpened(event) {
    this.columnApi.autoSizeAllColumns();
  }

  async onSearchSubmit(searchForm: any) {
    this.currentSearchForm = searchForm;
    await this.getTravelInsuranceReport(searchForm);
  }

  getTravelInsuranceReport(searchForm: any): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        this.formLoading = true;
        searchForm.saleDateStart = this.addLocalTimeToDateTime(new Date(searchForm.saleDateStart));
        searchForm.saleDateEnd = this.addLocalTimeToDateTime(new Date(searchForm.saleDateEnd));
        this.reportService.travelInsuranceReport(searchForm)
          .subscribe(
            res => {
              this.travelInsuranceReportData = res?.data?.travelInsurance || [];
              this.gridApi?.setGridOption('rowData', this.travelInsuranceReportData);
              this.gridApi?.autoSizeAllColumns();
              this.messageService.add({ severity: 'success', summary: 'Success', detail: "Travel Insurance Report Fetched Successfully", life: 3000 });
              resolve(res);
            },
            err => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
              reject(err);
            },
            () => { this.formLoading = false; }
          );
      } catch (error) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: getTravelInsuranceReport' });
        this.formLoading = false;
        resolve({});
      }
    });
  }

  addLocalTimeToDateTime(datetime) {
    return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
  }
}
